import {makeVar} from "@apollo/client";

export const currentUserVar = makeVar({});

export function setFromInitialLoadQuery(initialLoadQuery) {
  currentUserVar(initialLoadQuery.currentUser);
}
